import {useEffect} from "react";


const Share = ({}) => {
    useEffect(() => {

        const actionShare = (query,link) =>{
            var button = document.querySelector(query);
            if (button) {
                let encodedURL = encodeURI(window.location.href);
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    window.open(`${link}${encodedURL}`);
                })
            }
        }
        // var button = document.querySelector('[ms-plugin="share-facebook"]');
        var likefb = document.querySelector('[ms-plugin="like-facebook"]');
        // if (button) {
        //     let encodedURL = encodeURI(window.location.href);
        //     button.addEventListener('click', (e) => {
        //         e.preventDefault();
        //         window.open(`https://facebook.com/sharer/sharer.php?u=${encodedURL}`);
        //     })
        // }
        if (likefb) {
            let encodedURL = encodeURI(window.location.href);
            likefb.setAttribute('data-href', encodedURL);
        }
        actionShare('[ms-plugin="share-facebook"]' ,'https://www.facebook.com/sharer/sharer.php?u=')

        actionShare('[ms-plugin="share-tw"]' ,'https://twitter.com/intent/tweet?url=')
        actionShare('[ms-plugin="share-gmail"]' ,'mailto:?subject=')
       // actionShare('[ms-plugin="share-gmail"]' ,'mailto:?subject=testbody=this is a test"')

    }, [])

    return null
};
export default Share;